import { onLinkHasChanged } from 'owa-link-data';
import { getAllRecipients } from '../utils/getAllRecipients';
import { updateRecipientsOnLink } from '../utils/updateRecipientsOnLink';
import { RecipientMemberInfo } from 'owa-recipient-types/lib/types/RecipientMemberInfo';
import { orchestrator } from 'satcheljs';
import { lazyResetSharingRecipientsInfo } from 'owa-link-data';
import { shouldCheckPermForLink } from '../utils/shouldCheckPermForLink';

orchestrator(onLinkHasChanged, async actionMessage => {
    if (!shouldCheckPermForLink(actionMessage.linkId)) {
        return;
    }

    const resetSharingRecipientsInfo = await lazyResetSharingRecipientsInfo.import();
    resetSharingRecipientsInfo(actionMessage.linkId);

    const allRecipients: RecipientMemberInfo[] = await getAllRecipients(
        [actionMessage.linkId],
        actionMessage.recipientInfos,
        actionMessage.composeId,
        actionMessage.isCalendar
    );

    if (allRecipients.length === 0) {
        return;
    }

    await updateRecipientsOnLink(actionMessage.linkId, allRecipients, actionMessage.composeId);
});
